import { AuthForm, AuthFormState } from '@knots/shared-frontend'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { knotsCFApiSdk } from '@/lib/fetcher'
import { toastSuccess } from '@/utils/toast'
import { AuthLayout, useAuth } from '@/features/auth'
import { LoadingOverlay } from '@/components/ui/Loaders'
import { useTheme } from '@/providers/theme'
import { Theme } from '@/config/app'
import { useAuthSearchParams, useRedirect } from '@/app/routes/Auth/hooks'
import { defaultUtmSource } from '@/config'

export const Register = () => {
  const { theme } = useTheme()
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { redirectUrl, inviteToken, oauthEmail } = useAuthSearchParams()
  const redirect = useRedirect()

  return (
    <div className="auth-route">
      <AuthLayout
        title={t('auth.register.title')}
        content={
          <AuthForm
            knotsApiSdk={knotsCFApiSdk}
            state={AuthFormState.Register}
            onError={() => {}}
            onLoginSuccess={({ access_token, stayLoggedIn }) => {
              login(access_token, stayLoggedIn)
              toastSuccess(t('auth.register.alert.success'))
              if (redirectUrl) {
                redirect(redirectUrl)
              } else {
                navigate({ pathname: '/', search: location.search })
              }
            }}
            switchToLogin={() => {
              navigate({ pathname: '/auth/login', search: location.search })
            }}
            email={oauthEmail}
            inviteToken={inviteToken}
            location={location}
            onLoading={setLoading}
            gsiButtonConfig={{ theme: theme === Theme.Light ? 'outline' : 'filled_black' }}
            source={defaultUtmSource}
          />
        }
        // footer={<AlreadyRegistered />}
      />
      <LoadingOverlay loading={loading} />
    </div>
  )
}
